// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__1kwdU","notes":"Notes_notes__3UzSH","note":"Notes_note__3pIQZ","markdown":"Notes_markdown__katfP"};